import React, { createContext, useContext, useMemo } from 'react'

const GenealogyTrees = createContext()

export const useGenealogyTreesContext = () => {
  const context = useContext(GenealogyTrees)
  if (!context) throw new Error('You need to use the GenealogyTreesProvider to use the useGenealogyTrees')
  return context
}

export default function GenealogyTreesProvider({ children, genealogyTreesData }) {
  const value = useMemo(() => genealogyTreesData, [genealogyTreesData])
  return <GenealogyTrees.Provider value={value}>{children}</GenealogyTrees.Provider>
}
